import { render, staticRenderFns } from "./TicketItems.vue?vue&type=template&id=5573342f&"
import script from "./TicketItems.vue?vue&type=script&lang=js&"
export * from "./TicketItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports